import React, { useEffect, useRef, useState } from "react";

export const AutoComplete = ({
    cambiarOpcionSeleccionada,
    funcionListaElementos,
    elementos,
    clasesAdicionales,
    mantenerSeleccion = true
}) => {
    const inputBusqueda = useRef()
    const classNameInput = "containerScroll text-white h-[30px] rounded px-4 w-full bg-zinc-800 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500 caret-white"   

    const [muestraOpciones,setMuestraOpciones] = useState(false)

    useEffect(() => {
        const funcionFocus = () => {
            setMuestraOpciones(true)
        }
        const funcionBlur = () => {
            setTimeout(() => {
                setMuestraOpciones(false)
            }, 200);
        }
        const inputElement = inputBusqueda.current
        
        inputElement.addEventListener('focus',funcionFocus)
        inputElement.addEventListener('blur',funcionBlur)

        return () => {
            inputElement.removeEventListener('focus', funcionFocus);
            inputElement.removeEventListener('blur', funcionBlur);
        };
    },[])
    
    return (
        <div className={`w-[200px] relative ${clasesAdicionales}`}>
            <input 
                onChange={e => {
                    funcionListaElementos(e.target.value || '')
                    if(e.target.value == ''){
                        cambiarOpcionSeleccionada(0)
                    }
                }}
                ref={inputBusqueda}
                placeholder="(Producto)" 
                className={classNameInput}
            />
            <div className={`${muestraOpciones ? '' : 'hidden'} absolute w-full top-full h-auto border border-[#767676] z-50`}>
                <ul className="overflow-auto max-h-[300px] containerScroll">
                    {
                        elementos.map((data,i) => { //PRUEBA
                            return(
                                <li 
                                    key={i+1} 
                                    onClick={() => {
                                        cambiarOpcionSeleccionada(data.codRepuesto)
                                        inputBusqueda.current.value = mantenerSeleccion ? data.nombreRepuesto : ''
                                        !mantenerSeleccion && funcionListaElementos('')
                                    }} 
                                    className="hover:bg-[#1967d2] bg-[#27272a] p-2 cursor-pointer text-xs"
                                >
                                    {data.nombreRepuesto}
                                </li>
                            )
                        })
                    }
                </ul>
            </div>
        </div>
    )
};
